import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gwalior-one-day-chess-tournament',
  templateUrl: './gwalior-one-day-chess-tournament.component.html',
  styleUrls: ['./gwalior-one-day-chess-tournament.component.scss']
})
export class GwaliorOneDayChessTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
